import { tableFilter } from 'features/collaborateur/types';
import React, { FC, useEffect, useState } from 'react';

interface FilterCheckboxProps {
  value: number;
  label: string;
  count: number;
  color: string;
  filterKey: string;
  filters: unknown;
  setfilters: React.Dispatch<React.SetStateAction<tableFilter>>;
  size?: string;
}

const FilterCheckbox: FC<FilterCheckboxProps> = ({
  value,
  label,
  count,
  color,
  filterKey,
  filters,
  setfilters,
  size,
}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const currentFilter = filters.filters?.[filterKey] || [];
    setChecked(currentFilter.includes(value));
  }, [filters, filterKey, value]);

  const onchangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setChecked(checked);

    const currentFilter = filters.filters?.[filterKey] || [];

    if (checked && !currentFilter.includes(value)) {
      setfilters((prevFilters: unknown) => ({
        ...prevFilters,
        filters: {
          ...prevFilters.filters,
          [filterKey]: [...currentFilter, value],
        },
      }));
    } else if (!checked && currentFilter.includes(value)) {
      const updatedFilter = currentFilter.filter(
        (item: number) => item !== value,
      );

      setfilters((prevFilters: tableFilter) => ({
        ...prevFilters,
        filters: {
          ...prevFilters.filters,
          [filterKey]: updatedFilter,
        },
      }));
    }
  };

  return (
    <label className="minthr-badge-check">
      <input
        onChange={onchangeHandler}
        type="checkbox"
        className="status-filters minthr-hidden-item"
        value={value.toString()}
        checked={checked}
      />
      <a
        className={`minthr-flex minthr-flex-items-center minthr-border minthr-badge minthr-px-3 minthr-ml-3 minthr-mobile-ml-0 minthr-mobile-w-100 minthr-badge-opacity-${color} ${
          size === 'm'
            ? ' minthr-py-1 minthr-mobile-mb-2'
            : ' minthr-mobile-px-2 minthr-mobile-mb-4'
        }`}
      >
        <h5 className="minthr-color-dark minthr-mr-2 minthr-line-height-30">
          {label}
        </h5>
        <span className={`minthr-color-${color} minthr-mobile-ml-auto`}>
          {count}
        </span>
      </a>
    </label>
  );
};

export default FilterCheckbox;
